enum Env {
    LOCAL      = 'local',
    TESTING    = 'testing',
    PRODUCTION = 'production'
}

export default Env;
